import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-viewFive',
  templateUrl: './viewFive.component.html',
  styleUrls: ['./viewFive.component.css']
})
export class ViewFiveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
